// ABOUTME: Static PRO status badge component for displaying athlete/user PRO subscription status
// ABOUTME: Default purple style; "paidByCoach" variant turns it blue and accepts an optional tooltip

import CTooltip from "./CTooltip"

type Variant = "default" | "paidByCoach"

interface CProBadgeProps {
  className?: string
  variant?: Variant
  // When provided, the badge is wrapped in CTooltip and shows this text on hover.
  tooltip?: string
}

const VARIANT_CLASS: Record<Variant, string> = {
  default: "bg-purple-100 text-purple-800",
  paidByCoach: "bg-blue-100 text-blue-800",
}

export const CProBadge = ({ className = "", variant = "default", tooltip }: CProBadgeProps) => {
  const badge = (
    <span
      className={`shrink-0 rounded-lg px-2.5 py-0.5 text-sm font-medium whitespace-nowrap ${VARIANT_CLASS[variant]} ${className}`}
    >
      PRO
    </span>
  )

  if (tooltip) {
    return (
      <CTooltip
        content={tooltip}
        placement="top"
      >
        {badge}
      </CTooltip>
    )
  }

  return badge
}

export default CProBadge
